import React from "react";
import { useSelector } from "react-redux";
import MovieList from "../browse/MovieList";
import ShowShimmer from "../shimmer/ShowShimmer";
import { RootState } from "../../store";

const GptMovieSuggestions = () => {
  const { movieResults, movieNames } = useSelector((store: RootState) => store.gpt);

  if (!movieNames) return null;
  if (!movieResults) return <ShowShimmer />;

  return (
    <div className="mt-12 bg-black/80 backdrop-blur-md rounded-2xl p-6 md:p-8 border border-white/10 shadow-2xl animate-fade-in mb-20">
      <div className="space-y-10">
        {movieNames.map((name, index) => (
          <MovieList
            key={name}
            title={name}
            movies={movieResults[index]}
          />
        ))}
      </div>
    </div>
  );
};

export default GptMovieSuggestions;
